import styled from "styled-components";
import { DEFAULT_ROW_HEIGHT } from "../../Table/constants.js";
const ColumnOverlayWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0;
  z-index: 100;
  width: ${(props) => props.width}px;
  transition: width 0.3s ease-in-out;

  &:after {
    content: '';
    position: absolute;
    inset: 0;
    background-color: ${(props) => props.state === "requiresDecision" ? "var(--colors-base-transparent)" : props.theme.cell.selected.backgroundColor};
    opacity: 0.3;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: ${DEFAULT_ROW_HEIGHT}px;
    right: 0;
    left: ${(props) => props.leftOffset}px;
    border: 1px solid
      ${(props) => props.state === "requiresDecision" ? "var(--colors-amber-9)" : props.theme.column.selected.borderColor};
  }
`;
const CellOverlayWrapper = styled.div`
  position: absolute;
  top: 32px;
  left: 0;
  width: 100%;
  height: calc(100% - 32px);
`;
export {
  CellOverlayWrapper,
  ColumnOverlayWrapper
};
